import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import {
  useV1ListCurrencies,
  V1ListCurrenciesTypeEnum,
} from "@rentablo/api/apiv1";

export interface CurrencySelectProps {
  label: string;
  value: string | undefined;
  onChange: (code: string) => void;
  testId?: string;
  id?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  type?: V1ListCurrenciesTypeEnum[];
}

export const CurrencySelect = ({
  label,
  value,
  onChange,
  testId,
  id,
  fullWidth = true,
  disabled,
  type,
}: CurrencySelectProps) => {
  const { data, isLoading } = useV1ListCurrencies(type ? { type } : undefined);

  const currencies = data?.currencies ?? [];

  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel>{label}</InputLabel>
      <Select
        id={id}
        data-testid={testId}
        value={value ?? ""}
        onChange={(event: SelectChangeEvent<string>) =>
          onChange(event.target.value)
        }
        disabled={disabled || isLoading}
        inputProps={testId ? { "data-testid": `${testId}-input` } : undefined}
      >
        {currencies.map(({ code, name }) => (
          <MenuItem
            key={code ?? ""}
            data-testid={testId ? code : undefined}
            value={code ?? ""}
          >
            {code ?? ""} - {name ?? ""}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
